// extracted by mini-css-extract-plugin
module.exports = {"container":"top-info-bar_container__ddk1b","text":"top-info-bar_text__QV742","bold":"top-info-bar_bold__L9DQK"};